module.exports = __webpack_public_path__ + "img/support.0b6a8ef5.png";